import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { USUARIO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    USUARIO_ENDPOINT
  ]);
}

export async function fetchAllAnalistas() {
  return doGetQCXRequest([
    USUARIO_ENDPOINT, 'analista'
  ]);
}

export async function fetchAllByTenant() {
  return doGetQCXRequest([
    'crawler', 'find-all-usuarios-by-tenant'
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    USUARIO_ENDPOINT,
    id
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [USUARIO_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [USUARIO_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [USUARIO_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [USUARIO_ENDPOINT],
    id
  );
}
